import React, { CSSProperties, forwardRef } from 'react'

import { ExternalStyles, Theme, useStyles } from '../../styles'
import { Omit } from '../../util'
import { useModalContext } from '../../hooks'

import { ModalScroll } from './Modal'

export interface ModalContainerProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'style'> {
  style?: ExternalStyles
}

export const ModalContainer = forwardRef<HTMLDivElement, ModalContainerProps>((props, ref) => {
  const { style, children, ...rest } = props

  const { scroll, hasHeader } = useModalContext()
  const { classes, css } = useStyles(createStyles, scroll, hasHeader)

  return (
    <div role='dialog' aria-modal='true' ref={ref} className={css(classes.wrapper, style)} {...rest}>
      <div className={classes.inner}>{children}</div>
    </div>
  )
})

const createStyles = (theme: Theme, scroll: ModalScroll, hasHeader: boolean) => {
  const gridTemplateRowsScrollBody = hasHeader ? 'auto 1fr auto' : '1fr auto'
  return {
    wrapper: {
      maxHeight: '80vh',
      border: `1px solid ${theme.pallete.divider}`,
      boxShadow: theme.shadows.outer['160'],
      borderRadius: theme.radius.modal,
      backgroundColor: theme.pallete.surface.main,
      minWidth: 520,
      pointerEvents: 'auto',
      overflow: scroll === 'body' ? 'hidden' : 'auto',
      display: 'grid',
      gridTemplateRows: '1fr',
    } as CSSProperties,
    inner: {
      display: 'grid',
      gridTemplateColumns: 'auto 1fr auto',
      gridTemplateRows: scroll === 'body' ? gridTemplateRowsScrollBody : 'max-content',
      height: '100%',
      minHeight: 0,
    } as CSSProperties,
  }
}
